<template>
  <div>
    <div style="display: flex">
      <!-- <Select v-model="queryType" style="width: 200px; margin-right: 5px">
        <Option
          v-for="item in typeList"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select> -->
      <Input
        @on-focus="() => (dropDown = true)"
        @on-blur="blurFun"
        v-model="queryValue"
      >
        <Select v-model="queryKey" slot="prepend" style="width: 150px">
          <Option v-for="s in searchParam" :key="s.value" :value="s.value">{{
            s.text
          }}</Option>
        </Select>
        <Button slot="append" class="search" @click="handleSearch">搜索</Button>
      </Input>
      <Card
        class="intelligence"
        v-if="
          queryValue && dropDown && searchOptions && searchOptions.length > 0
        "
      >
        <div
          :class="{ activeProject: isActive === it.EngId }"
          @click="setSearch(it)"
          v-for="it in searchOptions"
        >
          {{ it.Data }}
        </div>
      </Card>
    </div>
    <div v-if="tipsVisible" class="tips">
      <div class="text">请在上方输入条件进行查询</div>
      <Alert
        type="warning"
        v-for="(s, index) in $config.searchTips"
        :key="index"
        ><span v-html="s"></span
      ></Alert>
    </div>
    <div v-else>
      <div class="operation operation-left">
        <Button
          type="primary"
          :disabled="!selection.length"
          @click="handleOpenSelectionModal"
          >已选工程 ( {{ selection.length }} )</Button
        >
        <Button type="primary" :disabled="!selection.length" @click="handleNext"
          >下一步</Button
        >
      </div>
      <Table border :loading="loading" :columns="columns" :data="data"></Table>
      <!-- pageSize > 10 页码选择大于10条也显示分页 -->
      <Page
        v-if="totalCount > pageSize || pageSize > 10"
        class="myPage"
        show-sizer
        show-elevator
        show-total
        :total="totalCount"
        :page-size="pageSize"
        :current="currentPage"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSizeChange"
      ></Page>
    </div>
    <SelectionModal
      ref="selectionModal"
      :selection="selection"
      @on-cancel-apply="handleCancelApply"
    />
  </div>
</template>

<script>
import { GetARCHIVES, BuildingListTips,BuildingList, GetArchive } from "@api";
import SelectionModal from "./selectionModal";
export default {
  name: "step1",
  components: { SelectionModal },
  data() {
    return {
      dropDown: true,
      selectIndex: false,
      queryType: "1",
      isActive: "",
      searchOptions: [],
      typeList: [
        { label: "工程信息查档", value: "1" },
        { label: "统一编码地址查询", value: "2" },
      ],
      columns: [],
      searchParam: [],
      queryKey: "ProjectName",
      queryValue: "",
      data: [],
      selection: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      tipsVisible: true,
      loading: true,
      timeIndex: null,
    };
  },
  mounted() {
    this.buildSearchParam();
    this.buildColumns();
  },
  watch: {
    // dropDown: {
    //   handler: function (val) {
    //     alert(val);
    //     if (val) {
    //       setTimeout(() => {
    //         this.selectIndex = false;
    //       }, 100);
    //     } else {
    //       setTimeout(() => {
    //         this.selectIndex = true;
    //         if (this.QueryValue) {
    //           this.getBuildListTips();
    //         }
    //       }, 100);
    //     }
    //   },
    // },
    queryType(value) {
      if (value === "1") {
        this.buildSearchParam("1");
        this.queryKey = "ProjectName";
      } else if (value === "2") {
        this.buildSearchParam("2");
        this.queryKey = "BuildingName";
      }
    },
    queryValue: {
      handler: function (val, oldVal) {
        if (val) {
          if (this.timeIndex) {
            clearTimeout(this.timeIndex);
          }
          // this.timeIndex = setTimeout(() => {
          //   this.getBuildListTips();
          // }, 500);
        } else {
          this.searchOptions = [];
        }
      },
    },
  },
  methods: {
    blurFun() {
      setTimeout(() => {
        this.dropDown = false;
      }, 100);
    },
    async setSearch(val) {
      this.queryValue = val.Data;
      this.isActive = val.EngId;
      const res = await GetArchive({ engId: val.EngId });
      this.tipsVisible = false;
      this.loading = false;
        this.queryType==="2"
          ? this.buildColumns("2")
          : this.buildColumns("1")
      this.data = res.data.list;
      this.totalCount = res.data.total;
    },
    getBuildListTips() {
      BuildingListTips({
        QueryKey: this.queryKey,
        QueryValue: this.queryValue,
      }).then((res) => {
        this.searchOptions = res.data.list;
      });
    },
    buildSearchParam(value = "1") {
      if (value === "1") {
        this.searchParam = [
          {
            value: "ProjectName",
            text: "工程名称",
          },
          {
            value: "UnitName",
            text: "建设单位名称",
          },
          {
            value: "UnitApproval",
            text: "立项批准单位",
          },
          {
            value: "PlanningPermit",
            text: "规划许可证",
          },
          {
            value: "LandPermit",
            text: "用地许可证",
          },
          {
            value: "Area",
            text: "建筑面积",
          },
          {
            value: "ENGID",
            text: "档号",
          },
        ];
      } else if (value === "2") {
        this.searchParam = [
          {
            value: "BuildingName",
            text: "建筑物地址",
          },
          {
            value: "BuildingCode",
            text: "地址编码",
          },
        ];
      }
    },
    buildColumns(value = "1") {
      if (value === "1") {
        this.columns = [
          {
            title: "工程名称",
            key: "PROJECTNAME",
          },
          {
            title: "建设单位",
            key: "UNITNAME",
          },
          {
            //   title: '立项批准单位',
            //   key: 'UNITAPPROVAL'
            // }, {
            //   title: '规划许可证',
            //   key: 'PLANNINGPERMIT',
            //   align: 'center',
            //   width: 140
            // }, {
            //   title: '用地许可证',
            //   key: 'LANDPERMIT',
            //   align: 'center',
            //   width: 140
            // }, {
            //   title: '建筑面积',
            //   key: 'AREA',
            //   align: 'center',
            //   width: 100
            // }, {
            title: "档号",
            key: "ENGID",
            align: "center",
            width: 140,
          },
          {
            title: "工程流水号",
            key: "ENG_NO",
            align: "center",
            width: 120,
          },
          {
            title: "进馆日期",
            key: "MOVEDATE",
            align: "center",
            width: 120,
          },
          {
            title: "操作",
            align: "center",
            width: 140,
            render: (h, { row }) => {
              return (
                <div class="btnGroup">
                  <Button
                    type="info"
                    size="small"
                    disabled={this.selection.some((s) => s.ID === row.ID)}
                    onClick={() => this.handleApply(row)}
                  >
                    申请
                  </Button>
                  <Button
                    type="info"
                    size="small"
                    onClick={() => this.handleCancelApply(row)}
                  >
                    取消
                  </Button>
                </div>
              );
            },
          },
        ];
      } else if (value === "2") {
        this.columns = [
          {
            title: "建筑物名称",
            key: "BUILDING_NAME",
          },
          {
            title: "建筑物地址",
            key: "BUILDING_ADDRESS",
          },
          {
            title: "建筑物编码",
            key: "BUILDING_CODED",
          },
          {
            title: "工程名称",
            key: "PROJECTNAME",
          },
          {
            title: "建设单位",
            key: "UNITNAME",
          },
          {
            title: "档号",
            key: "ENGID",
          },
          {
            title: "工程流水号",
            key: "ENG_NO",
          },
          {
            title: "工程流水号",
            key: "MOVEDATE",
          },
          {
            title: "操作",
            align: "center",
            width: 140,
            render: (h, { row }) => {
              return (
                <div class="btnGroup">
                  <Button
                    type="info"
                    size="small"
                    disabled={this.selection.some((s) => s.ID === row.ID)}
                    onClick={() => this.handleApply(row)}
                  >
                    申请
                  </Button>
                  <Button
                    type="info"
                    size="small"
                    onClick={() => this.handleCancelApply(row)}
                  >
                    取消
                  </Button>
                </div>
              );
            },
          },
        ];
      }
    },
    async getPage() {
      this.loading = true;
      try {
        const query = {
          PageIndex: this.currentPage,
          PageSize: this.pageSize,
          QueryKey: this.queryKey,
          QueryValue: this.queryValue,
        };
        const {
          data: { total, list },
        } =  this.queryType==="2"
          ? await BuildingList(query)
          : await GetARCHIVES(query);
        this.queryType==="2"
          ? this.buildColumns("2")
          : this.buildColumns("1")
        this.data = list;
        this.totalCount = total;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    handleApply(row) {
      this.selection.push(row);
    },
    handleCancelApply({ ID }) {
      const index = this.selection.findIndex((f) => f.ID === ID);
      if (index < 0) return;
      this.selection.splice(index, 1);
    },
    handlePageChange(currentPage) {
      this.currentPage = currentPage;
      this.getPage();
    },
    handlePageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getPage();
    },
    handleOpenSelectionModal() {
      this.$refs["selectionModal"].open();
    },
    handleNext() {
      const onOk = () => {
        this.$emit("on-selection", this.selection);
        this.$emit("on-next");
      };
      this.$Modal.confirm({
        title: "提示",
        width: 500,
        content: `<p style="text-indent: 2rem;">${window.config.selectProjectTips}</p>`,
        onOk,
      });
    },
    handleSearch() {
      this.tipsVisible = false;
      this.getPage();
    },
  },
};
</script>

<style lang="less" scoped>
.intelligence {
  position: absolute;
  top: 110px;
  right: 60px;
  width: 71%;
  // height: 60px;
  z-index: 999;
  div {
    padding: 10px;
    cursor: pointer;
  }
  .activeProject {
    color: #1976d2;
  }
}
.myPage {
  text-align: right;
  padding-top: 8px;
}
.tips {
  .text {
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
}
.operation-left {
  justify-content: flex-start;
}
.search {
  background: #2d8cf0;
  color: #fff;
}
</style>